import { render, staticRenderFns } from "./BookConsult.vue?vue&type=template&id=413969f2&scoped=true"
import script from "./BookConsult.vue?vue&type=script&lang=js"
export * from "./BookConsult.vue?vue&type=script&lang=js"
import style0 from "./BookConsult.vue?vue&type=style&index=0&id=413969f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "413969f2",
  null
  
)

export default component.exports